import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import CEQuickBuy from './CEQuickBuy.jsx';

const initQuickBuy = () => {
  const element = document.getElementById('quick-buy-react');

  if (!element) {
    console.warn('Quick Buy element not found');
    return;
  }

  // Read data attributes from the HTML element
  const locale = element.getAttribute('data-locale');
  const primaryLocale = element.getAttribute('data-primary-locale') === 'true';
  const country = element.getAttribute('data-country');
  const market = element.getAttribute('data-market');
  const addToCartText = element.getAttribute('data-add-to-cart-text') || '';
  const quickBuyMobileImgPreview = element.getAttribute('data-quick-buy-mobile-img-preview') || '';
  const sizeChartUrl = element.getAttribute('data-size-chart-url') || '';

  // Check if URL has #customize-jersey hash to auto-open drawer (mobile only)
  // Mobile breakpoint is 999px based on the CSS media queries
  const isMobile = window.innerWidth <= 999;
  const shouldOpenDrawer = window.location.hash === '#customize-jersey' && isMobile;

  createRoot(element).render(
    <StrictMode>
      <CEQuickBuy
        localization={{ locale, country, market }}
        primaryLocale={primaryLocale}
        addToCartText={addToCartText}
        quickBuyMobileImgPreview={quickBuyMobileImgPreview}
        sizeChartUrl={sizeChartUrl}
        autoOpenDrawer={shouldOpenDrawer}
      />
    </StrictMode>,
  );

  // Handle scroll for both #quick-buy and #customize-jersey hashes
  if (window.location.hash === '#quick-buy' || window.location.hash === '#customize-jersey') {
    const scrollToElement = () => {
      const rect = element.getBoundingClientRect();
      // Use window.scrollY instead of pageYOffset for better Safari compatibility
      const absoluteTop = rect.top + (window.scrollY || window.pageYOffset);
      const offsetTop = absoluteTop - 40; // Offset for header

      // Use window.scrollTo with fallback for Safari
      // Safari has issues with scrollIntoView + smooth behavior
      try {
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth',
        });
      } catch (e) {
        // Fallback for older browsers
        window.scrollTo(0, offsetTop);
      }
    };

    // Wait for window load to ensure all resources are loaded
    if (document.readyState === 'complete') {
      // Window already loaded, use setTimeout for Safari compatibility
      // Safari sometimes needs more time to calculate layout
      setTimeout(() => {
        scrollToElement();
      }, 100);
    } else {
      // Wait for window load event
      window.addEventListener('load', () => {
        setTimeout(() => {
          scrollToElement();
        }, 100);
      });
    }
  }
};

initQuickBuy();
